import React from 'react';
import { Box, Container, Grid, Stack } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import MapPinIcon from '../../kit/icons/MapPinIcon';
import FooterSubscription from './FooterSubscription/FooterSubscription';
import Skolkovo from '../../kit/icons/Skolkovo';
import styles from './styles';
import { VkOutlinedIcon } from '../../kit/icons/VkOutlinedIcon';
import { YouTubeOutlinedIcon } from '../../kit/icons/YouTubeOutlinedIcon';
import { TelegramOutlinedIcon } from '../../kit/icons/TelegramOutlinedIcon';

const contactLinks = [
  [
    {
      title: '+7 (499) 938-68-24',
      href: 'tel:+74999386824',
    },
  ],
  [
    {
      title: 'Чат в whatsApp',
      href: 'https://wa.me/74957860581',
    },
    {
      title: 'Telegram',
      href: 'https://t.me/elbrus_bootcamp',
    },
  ],
  [
    {
      title: 'info@elbrusboot.camp',
      href: 'mailto:info@elbrusboot.camp',
    },
  ],
];

const navigationLinks = [
  {
    title: 'О нас',
    href: '/about/',
  },

  {
    title: 'Программа лояльности',
    href: 'https://elbrusbootcamp.online/friends',
  },

  {
    title: 'События',
    href: '/events/',
  },
  {
    title: 'Блог',
    targetBlank: true,
    href: '/blog/',
  },
  {
    title: 'Контакты',
    href: '/contacts/',
  },
  {
    title: 'Вакансии',
    href: 'https://app.weeek.net/s/nashi-vakansii-document-NjE5NzY4fDlkMDY2ZjI2LWM5ODUtNGNmNC04Y2ZlLWVmNTg0MjM3MTkwMQ==',
    targetBlank: true,
  },
];

const iconLinks = [
  {
    href: 'https://vk.com/elbrusbootcamp',
    IconComponent: VkOutlinedIcon,
  },
  {
    href: 'https://www.youtube.com/channel/UCaKZxz2d1KI-wN3l6fX7zdQ/featured',
    IconComponent: YouTubeOutlinedIcon,
  },
  {
    href: 'https://t.me/elbrusbootcamp1',
    IconComponent: TelegramOutlinedIcon,
  },
];
const legalLinks = [
  {
    title: 'Политика обработки персональных данных',
    href: '/docs/confidentiality_agreement.pdf',
  },
  {
    title: 'Пользовательское соглашение',
    href: '/docs/end_user_license_agreement.pdf',
  },
  {
    title: 'Договор оферта',
    href: '/contract_agreements/',
  },
  {
    title: 'Об образовательной организации',
    href: 'https://tt.elbrusboot.camp/services',
  },
  {
    title: 'Государственная лицензия',
    href: '/docs/edu_license.pdf',
  },
];

export default function Footer() {
  return (
    <Box sx={styles.footerWrapper}>
      <Container
        maxWidth="xl"
        component="footer"
        sx={{
          padding: {
            xs: '0 16px',
            lg: '0 60px',
          },
        }}
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={4} sx={styles.firstColumn}>
            <Stack sx={styles.contactLinks}>
              {contactLinks.map((linkDesc, index) => (
                <Box key={`footer-${index}`} sx={styles.linkWrapper}>
                  {linkDesc.map((item) => (
                    <Box key={item.href} component="span" sx={styles.linkItem}>
                      <Link
                        href={item.href}
                        variant="kitSecondaryInverseWhite"
                        target="_blank"
                        sx={styles.link}
                      >
                        {item.title}
                      </Link>
                    </Box>
                  ))}
                </Box>
              ))}
            </Stack>
            <Stack direction="column" sx={styles.addressBlock}>
              <Box sx={styles.mapIconContainer}>
                <MapPinIcon />
              </Box>
              <Link
                href="https://www.google.com/maps/place/Elbrus+Coding+Bootcamp+%7C+Школа+программирования+Донской+район/@55.7065807,37.5926111,16.25z/data=!4m13!1m6!3m5!1s0x46b54bbba5624251:0x42cefa28cf581f67!2zRWxicnVzIENvZGluZyBCb290Y2FtcCB8INCo0LrQvtC70LAg0L_RgNC-0LPRgNCw0LzQvNC40YDQvtCy0LDQvdC40Y8g0JTQvtC90YHQutC-0Lkg0YDQsNC50L7QvQ!8m2!3d55.706541!4d37.5970071!3m5!1s0x46b54bbba5624251:0x42cefa28cf581f67!8m2!3d55.706541!4d37.5970071!15sChZFbGJydXMgQ29kaW5nIEJvb3RjYW1wWjAKFmVsYnJ1cyBjb2RpbmcgYm9vdGNhbXAiFmVsYnJ1cyBjb2RpbmcgYm9vdGNhbXCSARBlZHVjYXRpb25fY2VudGVy"
                variant="kitSecondaryInverseWhite"
                target="_blank"
                sx={styles.mapInfo}
              >
                Москва, ул. Орджоникидзе, 11 стр. 10
                <br />
                (м. Ленинский проспект)
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6} lg={4.5} sx={styles.secondColumn}>
            <Stack>
              {navigationLinks.map((linkDesc, idx) => (
                <Box key={linkDesc.href} sx={styles.linkWrapper}>
                  <Link
                    href={linkDesc.href}
                    variant="kitSecondaryInverseWhite"
                    sx={{ ...styles.link }}
                    target={linkDesc.targetBlank ? '_blank' : '_self'}
                  >
                    {linkDesc.title}
                  </Link>
                </Box>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={6} lg={3.5} sx={styles.thirdColumn}>
            <Box sx={styles.legalLinksWrapper}>
              <Stack sx={{ width: 'fit-content' }}>
                {legalLinks.map((linkDesc) => (
                  <Box key={linkDesc.href} sx={styles.linkWrapper}>
                    <Link
                      href={linkDesc.href}
                      variant="kitSecondaryInverseWhite"
                      sx={{ ...styles.link }}
                      target="_blank"
                    >
                      {linkDesc.title}
                    </Link>
                  </Box>
                ))}
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={styles.fourthColumn}>
            <Link href="https://navigator.sk.ru/orn/1123979" target="_blank">
              <Skolkovo sx={styles.logo} />
            </Link>
          </Grid>
          <Grid item xs={12} md={6} lg={4.5} sx={styles.fifthColumn}>
            <FooterSubscription />
          </Grid>
          <Grid item xs={12} md={6} lg={3} sx={styles.sixthColumn}>
            <Box sx={styles.socialContainer}>
              <Stack direction="row" spacing={3} sx={styles.social}>
                {iconLinks.map(({ href, IconComponent }) => (
                  <Link
                    key={href}
                    href={href}
                    variant="kitSecondaryInverse"
                    target="_blank"
                    sx={{ width: 'fit-content', color: 'transparent' }}
                  >
                    <IconComponent sx={styles.icon} />
                  </Link>
                ))}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
